module.exports = __webpack_public_path__ + "static/img/pending.2aab399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/pending.png
// module id = uruc
// module chunks = 1